import { Component, Input } from "@angular/core";import { Invoice } from "apps/idl/src/modules/facturation/models/invoice";

@Component({
	selector: "di-bandeau-facturation-degradee",
	templateUrl: "./bandeau-facturation-degradee.component.html",
	styleUrls: ["./bandeau-facturation-degradee.component.scss"],
})

export class BandeauFacturationDegradeeComponent  {
	@Input() public invoicesChecked: Invoice[] = [];
	@Input() public facturer?: Function;
	@Input() public selectionner?: Function;
	@Input() public toutSelectionner: boolean = true;

	public handleFacturer(){
		if(this.facturer) this.facturer();
	}

	public handleSelectionner(){
		if (this.selectionner) {
			this.selectionner(this.toutSelectionner);
		}
 	}
	
}
